import React from "react";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Dr. Anaya Sharma",
    role: "BDS, MDS • Sunrise Dental, Mumbai",
    quote:
      "The FDI chart alone saved me hours every week. My assistants pick up patient history in seconds. Best switch I've made.",
    initials: "AS",
  },
  {
    name: "Dr. Rohan Kapoor",
    role: "Endodontist • Bright Smile Clinic, Pune",
    quote:
      "WhatsApp reminders cut our no-shows by more than half. Patients love the confirmation flow, and I love that it just works.",
    initials: "RK",
  },
  {
    name: "Dr. Priya Menon",
    role: "Orthodontist • Kochi",
    quote:
      "Finally, a system built for dentists — not a rebadged CRM. The billing module is clean, GST-ready, and the invoices look pro.",
    initials: "PM",
  },
];

const Testimonials = () => (
  <section id="testimonials" className="bg-slate-50 py-20 md:py-28">
    <div className="max-w-[1200px] mx-auto px-6">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#14B8A6] mb-3">
          Loved by clinicians
        </div>
        <h2
          className="text-3xl md:text-[42px] font-extrabold text-[#0F2A5F] leading-tight mb-4"
          style={{ fontFamily: "'Open Sans', sans-serif" }}
        >
          What dentists are saying.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t) => (
          <div
            key={t.name}
            className="relative bg-white rounded-2xl p-7 border border-slate-200 shadow-sm hover:shadow-md transition-shadow"
          >
            <Quote size={28} className="text-[#14B8A6]/30 mb-3" />
            <p className="text-slate-700 leading-relaxed text-[15px] mb-6">
              “{t.quote}”
            </p>
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#0F2A5F] to-[#14B8A6] text-white flex items-center justify-center font-bold text-sm">
                {t.initials}
              </div>
              <div>
                <div className="font-semibold text-[#0F2A5F] text-sm">{t.name}</div>
                <div className="text-xs text-slate-500">{t.role}</div>
              </div>
            </div>
            <div className="flex gap-0.5 mt-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={13} className="text-amber-400" fill="currentColor" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
